import React from "react";
import Resume2 from "./Resume.pdf"

const CTA = () => {
    return (  
        <div className="cta">
            <a href= {Resume2} className="btn" >View Resume</a>
            
        </div>
    );
}
 
export default CTA;